import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from "@angular/core";
declare var toastr;

let configured = false;

@Injectable()
export class Notify {
  public toastr = toastr;

  constructor() {
    if (!configured && toastr && toastr.options) {
      toastr.options.preventDuplicates = true;
      toastr.options.newestOnTop = true;
      configured = true;
    }
  }

  success(title, message?) {
    toastr.success(this.text(message), this.text(title));
  }

  error(title, message?) {
    toastr.error(this.text(message), this.text(title));
  }

  warning(title, message?) {
    toastr.warning(this.text(message), this.text(title));
  }

  info(title, message?) {
    toastr.info(this.text(message), this.text(title));
  }

  clear() {
    return toastr.clear();
  }

  remove() {
    return toastr.remove();
  }

  httpErr(err: HttpErrorResponse | any) {
    this.error('Something went wrong', Notify.extractMessage(err));
  }

  saved(what?: string) {
    this.success(what ? what + ' saved' : 'Saved');
  }

  created(what?: string) {
    this.success(what ? what + ' created' : 'Created');
  }

  updated(what?: string) {
    this.success(what ? what + ' updated' : 'Updated');
  }

  removed(what?: string) {
    this.success(what ? what + ' removed' : 'Removed');
  }

  uploaded(what?: string) {
    this.success(what ? what + ' uploaded' : 'Uploaded');
  }

  copied() {
    this.success('Copied');
  }

  validation(message: string) {
    this.warning(message);
  }

  private text(value): string {
    if (value === null || value === undefined) return '';
    if (typeof value === 'string') return value;
    if (typeof value === 'number' || typeof value === 'boolean') return String(value);
    return Notify.extractMessage(value);
  }

  static extractMessage(err): string {
    if (err === null || err === undefined) return 'Unexpected error';
    if (typeof err === 'string') return err;

    const body = err.error !== undefined ? err.error : err._body;

    if (typeof body === 'string' && body.trim()) {
      const parsed = Notify.tryParse(body);
      if (parsed && typeof parsed === 'object') {
        return Notify.fromObject(parsed) || body;
      }
      return body;
    }

    if (body && typeof body === 'object') {
      const fromBody = Notify.fromObject(body);
      if (fromBody) return fromBody;
    }

    const fromErr = Notify.fromObject(err);
    if (fromErr) return fromErr;

    if (typeof err.message === 'string' && err.message && err.message.indexOf('Http failure') !== 0) {
      return err.message;
    }

    if (err.statusText) {
      return err.status ? err.status + ' ' + err.statusText : err.statusText;
    }

    if (err.message) return err.message;

    return 'Unexpected error';
  }

  private static fromObject(obj): string {
    if (!obj || typeof obj !== 'object') return '';

    if (Array.isArray(obj)) {
      const joined = obj.filter(x => typeof x === 'string' && x.trim()).join('; ');
      return joined || '';
    }

    const candidate = obj.message || obj.error || obj.detail || obj.title || obj.msg || obj.description;
    if (typeof candidate === 'string' && candidate.trim()) return candidate;

    if (Array.isArray(obj.errors)) {
      const joined = obj.errors
        .map(e => typeof e === 'string' ? e : (e && e.message))
        .filter(x => typeof x === 'string' && x.trim())
        .join('; ');
      if (joined) return joined;
    }

    return '';
  }

  private static tryParse(value: string) {
    try {
      return JSON.parse(value);
    } catch (e) {
      return null;
    }
  }
}
